import React from 'react';
import {Trans} from 'react-i18next';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import AsyncCustomerList from './customerlist/async';
import AsyncCustomerProfile from './customerprofile/async';
import {Redirect} from 'react-router';

const parent1 = {
  title: <Trans i18nKey="p.customer.title">Client</Trans>,
  path: '/client',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/client/client-list"
    component={AsyncCustomerList}
    parents={[parent1]}
    title={<Trans i18nKey="p.customer.customerlist.title">Client List</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="a"
    path="/client/client-profile"
    component={AsyncCustomerProfile}
    parents={[parent1]}
    title={
      <Trans i18nKey="p.customer.customerprofile.title">Client Profile</Trans>
    }
  />,
  <Redirect key="b" exact from="/client" to="/client/client-list" />,
];
